import React from 'react'
import { CenterBox } from '@repo/ui/components/center-box'
import { Typography } from '@repo/ui/components/typography'
import { useTranslate } from '@repo/shared/hooks'
import { ButtonLink } from '@repo/shared/components'
import Image from 'next/image'

export const WalletProjectsEmptyState = ({
  isLoading,
}: {
  isLoading: boolean
}) => {
  const { t } = useTranslate()

  return (
    <CenterBox className=' flex-col gap-lg py-10xl'>
      <Image src='/images/home.webp' alt='empty-state' width={64} height={64} />
      <Typography
        variant='p'
        size='sm'
        color='text-base-surface-100'
        className='text-center'
      >
        {t('walletProjectsEmptyState_title')}
      </Typography>
      <ButtonLink
        variant='ghost'
        size='sm'
        color='base'
        className='text-center'
        href='/projects'
        disabled={isLoading}
      >
        {t('walletProjectsEmptyState_cta')}
      </ButtonLink>
    </CenterBox>
  )
}
